export interface IProductsData {
    acceptedTerm?: boolean;
    tradingNotesSubmitted?: boolean;
    tradingNotesSubmittedDate?: Date;
    acceptedDate?: Date;
    portAll: boolean;
    products: IInvestorProducts;
    cblc: number | string;
}

export interface IInvestorRestrictions {
    hasRestrictions: boolean;
}

export interface IInvestorProducts {
    clientCode: number;
    variableIncome: IVariableIncome;
    fixedIncome: IProduct[];
    funds: IProduct[];
}

export interface IVariableIncome {
    stocks: IProduct[];
    options: IProduct[];
    proceeds: IProduct[];
    structuredOperations: IProduct[];
}

export interface IProduct {
    id?: string;
    code?: string; // Código do ativo ou produto
    product?: string; // Nome ou descrição do produto
    type?: string; // Tipo do produto (ex: CALL, JCP, FIA etc.)
    quantity: number; // Quantidade total
    transferQuantity?: number; // Quantidade a ser transferida
    businessDaysUntilPayment?: number; // Quantidade de dias úteis para próximo pagamento
    selected?: boolean;
    saved?: boolean;
    edition?: boolean;
}

export interface IEffectuationTypeData {
    type: EffectuationType;
}

export enum EffectuationType {
    Partial = '1',
    Total = '2'
}
